const Header = () => {
  $(document).on("click", ".menu-item-has-children > a", function (e) {
    e.preventDefault();
  });
  $(document).on("click", ".btn-menu-mobile", function () {
    $(".menu-mobile").toggleClass("open", "open");
  });
  $(document).on("click", ".ext-menu", function () {
    $(".menu-mobile").toggleClass("open", "open");
  });

  $(document).on("click", ".menu-item-has-children", function () {
    $(this).toggleClass("open", "open");
  });
};

export default Header;



// WEBPACK FOOTER //
// ./scripts/components/Header.js